/**
 * LocationSelectionsTree represents a tree of selected locations.
 */
import { SelectionsTree } from './selections_tree';
import { createContainingLocationSpecs } from '../../shared/model';
export class LocationSelectionsTree extends SelectionsTree {
    constructor(specs) {
        super(specs);
    }
    getContainingSpecs(forSpec) {
        return createContainingLocationSpecs(forSpec);
    }
}
